import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import { Button } from '@material-ui/core';

import {withRouter} from 'react-router-dom'
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './store/actions';

const styles = theme => ({
});

class Example extends Component {

    componentWillMount() {
        this.props.getExample();
    }
    
    handleButton = () => {
    }

    render()
    {
        const {currentExample} = this.props;
        
        return (
            <div>
                blank div
                    <Button
                        variant="contained"
                        onClick={this.handleButton}
                    >
                        Default
                    </Button>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch)
{
    return bindActionCreators({
        getExample : Actions.getExample,
    }, dispatch);
}

function mapStateToProps({example})
{
    return {
        currentExample: example.examples.currentExample
    }
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(Example)));



// WEBPACK FOOTER //
// src/main/content/example/Example.js